import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import { Button } from 'semantic-ui-react';
import ReactModal from 'react-modal';
import connect from 'react-redux/es/connect/connect';
import styled from 'styled-components';

const CancelBtn = styled.div`
  background-image: url('/img/cms/logo-blue.svg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
`;

const Container = styled.div`
  width: 590px;
  height: 302px;
  background: #FFFFFF;
  text-align: center;
  border-radius: 6px;
  margin-top: 70px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 26.4px;
  margin-top: 70px;
`;

const Content = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19.2px;
  width: 60%;
  margin: 20px;
  display: inline-block;
`;

const Footer = styled.div`
  margin-top: 20px;
`;

class CreateEventQuitModal extends Component {
  state = { open: false };

  handleOpen = (e) => {
    const { disabled = false } = this.props;
    if (disabled) return;
    e.stopPropagation();
    e.preventDefault();
    this.setState({ open: true });
  }

  handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ open: false });
  }

  redirectToHomePage = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.history.push('/');
  }

  render() {
    const { open } = this.state;
    const {
      translate
    } = this.props;

    const handleClose = (e) => {
      this.handleClose(e);
    };

    return (
      <Fragment>
        <a id='closeBtn' onClick={(e) => this.handleOpen(e)}>
          <CancelBtn />
        </a>
        <ReactModal
          isOpen={open}
          onRequestClose={(e) => { handleClose(e); }}
          className='promote-teams-modal'
          overlayClassName='promote-teams-overlay'
          ariaHideApp={false}
          onClick={e => { e.stopPropagation(); e.preventDefault(); }}
        >
          <Container>
            <Title>
              {translate('createEvent.quitModal.title')}
            </Title>
            <Content>
              {translate('createEvent.quitModal.content')}
            </Content>
            <Footer>
              <Button
                className='common-cancel-button'
                onClick={(e) => this.handleClose(e)}
              >
                {translate('button.cancel')}
              </Button>
              <Button
                className='team-detail-button'
                onClick={(e) => this.redirectToHomePage(e)}
              >
                {translate('button.quit')}
              </Button>
            </Footer>
          </Container>
        </ReactModal>
      </Fragment>
    );
  }
}

export default compose(
  withLocalize,
  withRouter,
  connect(({ cmsEvents, user, view }, { match: { params: { eventSlug } } }) => ({
    event: cmsEvents.event,
    user,
    view,
    eventSlug
  }))
)(CreateEventQuitModal);



// WEBPACK FOOTER //
// ./src/components/events/components/createEventQuitModal.js